import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';

let webAudio = null;

function useSound() {
  const soundRef = useRef(null);

  useEffect(() => {
    if (Platform.OS === 'web') {
      // For web, use HTMLAudioElement
      webAudio = new window.Audio('/assets/sound/smartsaasping.wav'); // Adjust path if needed
    } else {
      // For native, use Expo Audio
      (async () => {
        const { Audio } = await import('expo-av');
        await Audio.setAudioModeAsync({
          allowsRecordingIOS: false,
          staysActiveInBackground: false,
          playsInSilentModeIOS: true,
          shouldDuckAndroid: true,
          interruptionModeAndroid: Audio.INTERRUPTION_MODE_ANDROID_DO_NOT_MIX,
          interruptionModeIOS: Audio.INTERRUPTION_MODE_IOS_DO_NOT_MIX,
        });

        const { sound } = await Audio.Sound.createAsync(
          require('../../assets/sound/smartsaasping.wav')
        );
        soundRef.current = sound;
      })();
    }

    return () => {
      if (Platform.OS === 'web') {
        if (webAudio) {
          webAudio.pause();
          webAudio = null;
        }
      } else {
        if (soundRef.current) {
          soundRef.current.unloadAsync();
        }
      }
    };
  }, []);

  const playSound = async () => {
    if (Platform.OS === 'web') {
      if (webAudio) {
        webAudio.currentTime = 0;
        webAudio.play();
      }
    } else {
      if (soundRef.current) {
        const status = await soundRef.current.getStatusAsync();
        if (status.isLoaded) {
          await soundRef.current.replayAsync();
        }
      }
    }
  };

  return playSound;
}

export default useSound;
